module.exports = __webpack_public_path__ + "img/whitetick.ef2340ea.svg";